import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "./useGoogleAnalytics";
import { usePageTitle } from "../hooks/usePageTitle";

export function RouteAnalyticsProvider({ children }: React.PropsWithChildren) {
  const location = useLocation();
  const { trackPageView } = useAnalytics();
  const referrer = useRef(document.referrer);
  const { getPageTitle } = usePageTitle();

  useEffect(() => {
    // google analytics does not track the hash portion of the url, so we need to construct the full url manually
    // the protocol and host are needed for GA to resolve the hostname automatically
    const targetLocation = `${window.location.origin}${location.pathname}${location.search}`;
    // Only track if the location has actually changed, this is needed because some components might trigger a re-render without changing the location
    if (referrer.current === targetLocation) {
      return;
    }
    const title = getPageTitle();
    if (title) {
      document.title = title;
    }
    trackPageView(document.title, targetLocation, referrer.current);
    referrer.current = targetLocation;
  }, [location]);

  return <>{children}</>;
}
